import * as React from "react";

export function CanvasGrid({ panX, panY, scale }: { panX: number; panY: number; scale: number }) {
  const gridSize = 24 * scale;
  const offsetX = ((panX % gridSize) + gridSize) % gridSize;
  const offsetY = ((panY % gridSize) + gridSize) % gridSize;

  return (
    <svg aria-hidden="true" className="pointer-events-none absolute inset-0 size-full select-none">
      <defs>
        <pattern
          id="flow-canvas-grid-pattern"
          width={gridSize}
          height={gridSize}
          patternUnits="userSpaceOnUse"
          x={offsetX}
          y={offsetY}
        >
          <circle
            cx={gridSize / 2}
            cy={gridSize / 2}
            r={1.2 * Math.min(Math.max(scale, 0.7), 1.4)}
            className="fill-border/70"
          />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#flow-canvas-grid-pattern)" />
    </svg>
  );
}
